import {api} from '../../api/access-ctrl'
import {registerConfig} from '../../../components/common/di-ding'
import {commonConfig, routeNameOfDi} from '../common'
import {spDateFormat} from '../../../utils/util'
import inputDateHelper from '../../../components/common/inputs/_input-date-helper'

const mapping = {
  deviceName: {
    label: '门禁'
  },
  alarmType: {
    label: '报警类型',
    mapList: {
      map: {
        '1': '防拆报警',
        '2': '尾随报警',
        '5': '人员闯入报警'
      }
    }
  },
  alarmTime: {
    label: '报警时间'
  },
  responsiblePersonName: {
    label: '责任人'
  }
}

const config = {
  breadcrumb: [{
    value: '智慧门禁',
    name: 'accessCtrlDeviceManagementCenter'
  }, {
    value: '报警记录',
  }],
  center: {
    opBar: [ // 多少个元素代表多少行
      [ // 仅支持 flex布局
        {
          type: 'date-second',
          pickerOptions: {
            shortcuts: [
              inputDateHelper.OPTIONS.SHORTCUT.A_WEEK,
              inputDateHelper.OPTIONS.SHORTCUT.A_MONTH,
              inputDateHelper.OPTIONS.SHORTCUT.THREE_MONTHS
            ],
            disabledDate: inputDateHelper.OPTIONS.DISABLED_DATE.HENCEFORTH
          },
          default: inputDateHelper.time.todayRange,
          beforeDataIsGet ({requestBody}) {
            const [startTime, endTime] = inputDateHelper.time.todayRange()
            requestBody.startTime = spDateFormat(startTime)
            requestBody.endTime = spDateFormat(endTime)
          },
          entityInSearchRequestBody: (currentTime) => ({
            startTime: currentTime[0] || '',
            endTime: currentTime[1]  || ''
          })
        },
        {
          type: 'search-selector',
          label: '报警类型',
          searchKey: 'alarmType',
          fetchDetail: () => Promise.resolve(
            [{
              '_value': '1',
              '_label': '防拆报警'
            }, {
              '_value': '2',
              '_label': '尾随报警'
            }, {
              '_value': '5',
              '_label': '人员闯入报警'
            }]
          )
        },
        [
          {
            type: 'search-device-tree',
            label: '门禁',
            searchKey: 'deviceCode',
            fetchDetail: () => api.getDeviceTreeList()
              .then(list => {
                list.forEach(it => {
                  it._value = it.code
                  it._label = it.name
                })
                return list
              })
          },
          // {type: 'input-search', label: '姓名/学工号', searchKey: 'searchKey'},
          {
            type: 'button-download',
            label: '导出',
            getDownloadUrl: (requestBody) => api.exportAlarmRecord(requestBody),
            download: '开门记录'
          }
        ]
      ]
    ],
    table: {
      operations: []
    }
  },

  get: requestBody => api.getAlarmRecordPage(requestBody),

  mapping
}

registerConfig(routeNameOfDi.APP_CENTER_ACCESS_CTRL_CALL_POLICE, config)



// WEBPACK FOOTER //
// ./src/view/AccessCtrl/call-police/call-police.js